import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AppSettings, Storage } from '../../configs'

import { logoutAction } from '../../redux/actions/UserAction'
import { ClearMasterAction } from '../../redux/actions/MasterAction'
import { setNotActivePOAction } from '../../redux/actions/DocControlAction'
import Avatar from '@material-ui/core/Avatar';
import { MsalContext } from '@azure/msal-react';

const initial_hamberger_status = {
    aria_expanded: false,
    class: 'collapsed',
    collapsed: 'collapse',
};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hamberger_status: initial_hamberger_status,
    };

    this.renderUserLogged = this.renderUserLogged.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this._toggleHambergerBar = this._toggleHambergerBar.bind(this);
  }
  componentDidMount() {
    document.addEventListener("click", this.handleOutsideClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  }
  handleOutsideClick(e) {
    const popupElement = document.getElementById("mainnavbarSupportedContent");
    let targetElement = e.target; // clicked element

    do {
      if (targetElement === popupElement) {
        return;
      }
      // Go up the DOM
      targetElement = targetElement.parentNode;
    } while (targetElement);
    // if(popupElement &&  popupElement.classList && popupElement.classList.contains("show")){
    //     document.getElementById("navbarBtnClose").click();
    // }
  }

  static contextType = MsalContext;

  handleLogout(event) {
    event.preventDefault();
    const employeePIS = Storage.getEmployeePIS();
    let userName = employeePIS.employeeId;

    this.props.setNotActivePO(userName, null, this.props.sessionNo, false);
    this.props.logout();
    this.props.ClearMaster();

    const msalInstance = this.context.instance;
    if (this.context.accounts.length > 0) {

      const postLogoutRedirectUri = Storage.getPostLogoutRedirectUri();

      
      msalInstance.logoutRedirect({
        account: this.context.accounts[0],
        postLogoutRedirectUri: postLogoutRedirectUri ?? `https://localhost:3000/`,
      });

      Storage.clear();
    } else {
      this.props.history.push({
        pathname: AppSettings.loginUrl,
        params: `?mode=logout`,
      });
    }
  }

  _toggleHambergerBar() {
    let status = {};
    if (this.state.hamberger_status !== initial_hamberger_status) {
      // กรณีโชว์อยู่
      status = initial_hamberger_status;
    } // กรณีไม่โชว์อยู่
    else {
      status = {
        aria_expanded: true,
        class: "",
        collapsed: "collapse show",
      };
    }

    this.setState({
      hamberger_status: status,
    });
  }

  renderUserLogged() {
    const user = Storage.getUser();
    const role = Storage.getRole();
    const employeePIS = Storage.getEmployeePIS();

    let userName = "";
    let userFullName = "";

    if (employeePIS) {
      userName = employeePIS.employeeId;
      userFullName = employeePIS.employeeNameTH;
    }

    if (user && !employeePIS) {
      //ถ้าไม่มีข้อมูลบน PIS
      userName = user.userId;
      userFullName = user.firstName + " " + user.lastName;
    }

    return user !== null ? (
      <li className="sp-nav-item dropdown sp-user-topbar">
        <div className="sp-nav-item-user">
          <div className="sp-nav-item-userimg">
            <span className="sp-userimg">
              <Avatar
                src={
                  employeePIS.image
                    ? employeePIS.image
                    : "https://hq-web-s13.pttplc.com/directory/photo/" +
                      userName +
                      ".jpg"
                }
              />
            </span>
          </div>
          <div className="sp-nav-item-userdata">
            <a
              className="sp-nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {userFullName} ({role})
            </a>
            <div className="dropdown-menu">
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.handleLogout}
              >
                Switch User
              </a>
            </div>
          </div>
        </div>
      </li>
    ) : null;
  }

  render() {
    const today = new Date();
    const roleAdmin = Storage.getRoleAdmin();
    const role = Storage.getRole();
    const emp = Storage.getEmployeePIS();
    const appReadonly = Storage.getAppReadonly();


    return (
      <div className="sp-topheader-wrap">
        <div className="sp-header-wrap">
          <div id="primary-navigation" className="sp-primary-navigation">
            <div className="sp-menu">
              <a
                href="#"
                onClick={this._toggleHambergerBar}
                data-toggle="collapse"
                data-target="#mainnavbarSupportedContent"
                aria-controls="mainnavbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i
                  className="icon menu-hamberger"
                  style={{
                    visibility:
                      this.state.hamberger_status.collapsed !== "collapse show"
                        ? ""
                        : "hidden",
                  }}
                />
              </a>
            </div>
            <a href="#/mytask">
              <div className="sp-logo">
                <div className="logo-img">
                  <img src="/assets/images/ptt-logo.svg" alt="PTT" />
                </div>
                <h2 className="sp-top-header">Receipt Recording System</h2>
              </div>
            </a>
          </div>
          <div id="content-header">
            <div className="mobile-menu">
              <a
                href="#"
                className="menu-settings"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="icon icon-gear" />
              </a>
            </div>
            <ul
              className="sp-nav justify-content-end navbar-collapse collapse"
              id="navbarSupportedContent"
            >
              {this.renderUserLogged()}
            </ul>
          </div>
        </div>
        {/* menu */}
        <div
          className={`mainnavbar-collapse mainnavbar ${this.state.hamberger_status.collapsed}`}
          id="mainnavbarSupportedContent"
        >
          <div id="primary-navigation" className="sp-primary-navigation">
            <div className="sp-menu">
              <a
                href="#"
                type="button"
                id="navbarBtnClose"
                data-toggle="collapse"
                data-target="#mainnavbarSupportedContent"
                aria-controls="mainnavbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i
                  className="icon btn-close"
                  onClick={this._toggleHambergerBar}
                />
              </a>
            </div>
            {/* <div className="sp-logo">
                            <div className="logo-img"><img src="/assets/images/ptt-logo.svg" alt="PTT" /></div>
                            <h2 className="sp-top-header">Receipt Recording System</h2>
                        </div> */}
          </div>
          <nav
            className="topnav-menu"
            style={{
              background:
                "transparent url('../assets/images/bg_topbar_bl.png') repeat",
            }}
          >
            <div className="topnav-menu-box topnav-menu-home">
              <div className="topnav-menu-headerlink">
                <a
                  href={AppSettings.landingpageUrl}
                  className="topnav-menu-link topnav-menu-homelink"
                >
                  <i className="icon icon-home" />
                  <span>Home</span>
                </a>
              </div>
            </div>
            <div className="topnav-menu-box topnav-menu-list">
              <div className="topnav-menu-headerlink">
                <a className="topnav-menu-link topnav-menu-homelink">
                  <span>Receipt Recording System</span>
                </a>
              </div>
              <ul className="topnav-menu-linklist">
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#${AppSettings.defaultUrl}`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    RRS Home
                  </a>
                </li>
                {/* <li className="topnav-menu-linkitem">
                                    <a href={`#/checking_grir_rpa`} onClick={this._toggleHambergerBar} className="topnav-menu-link">กรอกข้อมูลบันทึกรายงานประชุมการตรวจรับ (Mom) และข้อมูล GR/IR/MR สำหรับ Run Bot ในระบบ RRS อัตโนมัติ</a>
                                </li>
                                <li className="topnav-menu-linkitem">
                                    <a href={`#/checking_no_grir_rpa`} onClick={this._toggleHambergerBar} className="topnav-menu-link">กรอกข้อมูลบันทึกรายงานประชุมการตรวจรับ (Mom) ในระบบ RRS เท่านั้น โดยหน่วยงานจัดหาจะบันทึก GR/IR ในระบบ SAP</a>
                                </li> */}
              </ul>
            </div>
            <div className="topnav-menu-box topnav-menu-list">
              <div className="topnav-menu-headerlink">
                <a className="topnav-menu-link topnav-menu-homelink">
                  <span>Report</span>
                </a>
              </div>
              <ul className="topnav-menu-linklist">
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#/search`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    Transaction Report
                  </a>
                </li>
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#/ReportReceipt`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    รายงานข้อมูลบันทึกการประชุม
                  </a>
                </li>
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#/Report`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    ใบตรวจรับการจัดซื้อ/จัดจ้าง
                  </a>
                </li>
                {emp &&
                emp.departmentCode &&
                emp.departmentCode.toString() == "80000084" ? (
                  <li className="topnav-menu-linkitem">
                    <a
                      href={`#/ReportOutstanding`}
                      onClick={this._toggleHambergerBar}
                      className="topnav-menu-link"
                    >
                      รายงาน Outstanding Days
                    </a>
                  </li>
                ) : (
                  <div />
                )}
              </ul>
            </div>
            <div className="topnav-menu-box topnav-menu-list">
              <div className="topnav-menu-headerlink">
                <a className="topnav-menu-link topnav-menu-homelink">
                  <span>หนังสือเกี่ยวข้องกับการปรับ</span>
                </a>
              </div>
              <ul className="topnav-menu-linklist">
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#/Adjustment`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    หนังสือเกี่ยวข้องกับการปรับ
                  </a>
                </li>
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#/NotiAdjustment`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    หนังสือแจ้งค่าปรับ
                  </a>
                </li>
                {/* <li className="topnav-menu-linkitem"> 
                                    <a href={`#/ReportReceipt`} onClick={this._toggleHambergerBar} className="topnav-menu-link">รายงานข้อมูลบันทึกการประชุม</a>
                                </li>
                                <li className="topnav-menu-linkitem">
                                    <a href={`#/Report`} onClick={this._toggleHambergerBar} className="topnav-menu-link">ใบตรวจรับการจัดซื้อ/จัดจ้าง</a>
                                </li> */}
              </ul>
            </div>
            {role == "R" || role == "C" || roleAdmin ? (
              <div className="topnav-menu-box topnav-menu-list">
                <div className="topnav-menu-headerlink">
                  <a className="topnav-menu-link topnav-menu-homelink">
                    {/* <span>{!roleAdmin ? <span>&nbsp;</span> : "Master"}</span></a> */}
                    <span
                      style={{
                        visibility:
                          role == "R" || role == "C" || roleAdmin
                            ? ""
                            : "hidden",
                      }}
                    >
                      {"Master"}
                    </span>
                  </a>
                </div>
                {(role == "R" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility: role == "R" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/user`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        User Management
                      </a>
                    </li>
                  </ul>
                )}
                {(role == "R" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility: role == "R" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/departmentmanage`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        Department Management
                      </a>
                    </li>
                  </ul>
                )}
                {(role == "R" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility: role == "R" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/departmentmap`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        Department Mapping
                      </a>
                    </li>
                  </ul>
                )}
                {roleAdmin && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility: role == "R" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      {/* style={{ visibility: roleAdmin ? '' : "hidden" }}> */}
                      <a
                        href={`#/doccontrol`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        Document Control
                      </a>
                    </li>
                  </ul>
                )}
                {appReadonly == false && (role == "R" || role == "C" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility:
                        role == "R" || role == "C" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/ChangeCommitteeTask`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        เปลี่ยนแปลงคณะกรรมการตรวจรับ
                      </a>
                    </li>
                  </ul>
                )}
                {appReadonly == false && (role == "R" || role == "C" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility:
                        role == "R" || role == "C" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/ExtendConsiderationPeriod`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        ขยายระยะเวลาพิจารณา
                      </a>
                    </li>
                  </ul>
                )}
                {(role == "R" || role == "C" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility:
                        role == "R" || role == "C" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      {/* <a target="_blank" href={`http://ptt-qshemgt-p01.ptt.corp/EISOWeb/DCS030.aspx?DarID=DAR-2020-002746`} onClick={this._toggleHambergerBar} className="topnav-menu-link">Template หนังสือเห็นแย้ง</a> */}
                      <a
                        target="_blank"
                        href={`${AppSettings.apiUrl}/api/Attachment/GetEISODoc?type=2`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        Template หนังสือเห็นแย้งพัสดุ
                      </a>
                    </li>
                  </ul>
                )}
                {(role == "R" || role == "C" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility:
                        role == "R" || role == "C" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        target="_blank"
                        href={`${AppSettings.apiUrl}/api/Attachment/GetEISODoc?type=1`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        Template หนังสือเห็นแย้งพาณิชย์
                      </a>
                    </li>
                  </ul>
                )}
             
                {(role == "R" || roleAdmin) && (
                  <ul
                    className="topnav-menu-linklist"
                    style={{
                      visibility: role == "R" || roleAdmin ? "" : "hidden",
                    }}
                  >
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/contractpomanage`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        จัดการสัญญาผู้ค้าสิ้นปี
                      </a>
                    </li>
                  </ul>
                )}
                {roleAdmin && (
                  <ul className="topnav-menu-linklist">
                    <li className="topnav-menu-linkitem">
                      <a
                        href={`#/configsessiontimeout`}
                        onClick={this._toggleHambergerBar}
                        className="topnav-menu-link"
                      >
                        กำหนด Session Timeout
                      </a>
                    </li>
                  </ul>
                )}
              </div>
            ) : (
              <div />
            )}

           {appReadonly == false &&
            <div className="topnav-menu-box topnav-menu-list">
              <div className="topnav-menu-headerlink">
                <a className="topnav-menu-link topnav-menu-homelink">
                  <span>{"User Manual"}</span>
                </a>
              </div>
              <ul className="topnav-menu-linklist">
                <li className="topnav-menu-linkitem">
                  <a
                    href={`#/manual`}
                    onClick={this._toggleHambergerBar}
                    className="topnav-menu-link"
                  >
                    User Manual
                  </a>
                </li>
              </ul>
            </div>}
            {/* <div className="topnav-menu-box topnav-menu-list">
                            <div className="topnav-menu-headerlink">
                                <br />
                            </div>
                        </div> */}
          </nav>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
    const { DocControlRedux } = state
    return {
        sessionNo: DocControlRedux.sessionNo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(logoutAction()),
        ClearMaster: () => dispatch(ClearMasterAction()),
        setNotActivePO: (userId, poNo, sessionNo, isDelete) => dispatch(setNotActivePOAction(userId, poNo, sessionNo, isDelete)),
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Header);
